import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

export interface NonConductedClassRow {
  yearName: string | null;
  schoolName: string | null;
  programName: string | null;
  termName: string | null;
  courseName: string | null;
  batchName: string | null;
  topicName: string | null;
  plannedInstructor: string | null;
  date: string | null;
  dateDisplay: string;
  startTime: string | null;
  endTime: string | null;
  timeSlotName: string;
}

export interface NonConductedClassesData {
  isProgramBased: boolean;
  startDate: string;
  endDate: string;
  total: number;
  rows: NonConductedClassRow[];
}

export interface NonConductedClassesResponse {
  success: boolean;
  data?: NonConductedClassesData;
  error?: string;
  message?: string;
}

export interface SchoolOption {
  schoolId: number;
  schoolName: string;
  schoolCode?: string;
}

export interface ReportFilters {
  startDate: string;
  endDate: string;
  schoolId?: number;
}

class NonConductedClassesService {
  private baseUrl = `${Config.nodeSiteUrl}v1/reports/non-conducted-classes`;
  private schoolsUrl = `${Config.nodeSiteUrl}v1/academic/schools`;

  /** Fetch the list of schools the user is authorized for (filter dropdown). */
  async getSchools(): Promise<SchoolOption[]> {
    const res = await (myAxios as any).get(this.schoolsUrl);
    const data = res?.data?.data;
    return Array.isArray(data)
      ? data.map((s: any) => ({
          schoolId: Number(s.schoolId),
          schoolName: s.schoolName,
          schoolCode: s.schoolCode,
        }))
      : [];
  }

  /** Fetch the non-conducted classes report. */
  async getReport(filters: ReportFilters): Promise<NonConductedClassesResponse> {
    const p = new URLSearchParams();
    p.set("startDate", filters.startDate);
    p.set("endDate", filters.endDate);
    if (filters.schoolId) p.set("school", String(filters.schoolId));
    const res = await (myAxios as any).get(`${this.baseUrl}?${p.toString()}`);
    return res.data;
  }

  /** Download the styled .xlsx export. Returns the file as a Blob. */
  async exportReport(filters: ReportFilters): Promise<Blob> {
    const p = new URLSearchParams();
    p.set("startDate", filters.startDate);
    p.set("endDate", filters.endDate);
    if (filters.schoolId) p.set("school", String(filters.schoolId));
    const res = await (myAxios as any).get(`${this.baseUrl}/export?${p.toString()}`, {
      responseType: "blob",
    });
    return res.data;
  }
}

export default new NonConductedClassesService();
